import {
  Box,
  IconButton,
  MenuItem,
  TextField,
  Typography,
  colors,
} from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'

import { MOTIVATIONAL_QUOTE_COLOR_OPTIONS } from '../constants'
import { Check, Close } from '@mui/icons-material'
import { updateObjectWithMatchingId } from '../utils/array'
import useAlert from '../hooks/useAlert'

const MotivationalQuote = ({ motivationalQuotes, saveMotivationalQuotes }) => {
  const [isEditing, setIsEditing] = useState(false)
  const { createGenericErrorAlert, createAlert } = useAlert()

  const randomIndex = useMemo(() => {
    return Math.floor(Math.random() * motivationalQuotes.length)
  }, [motivationalQuotes])

  const [localCopy, setLocalCopy] = useState(
    motivationalQuotes.find((q) => q.isSelected) ||
      motivationalQuotes[randomIndex]
  )

  useEffect(() => {
    if (!localCopy) {
      setLocalCopy(
        motivationalQuotes.find((q) => q.isSelected) ||
          motivationalQuotes[randomIndex]
      )
    }
  }, [motivationalQuotes])

  if (!localCopy) {
    return null
  }

  const onSave = () => {
    saveMotivationalQuotes(
      updateObjectWithMatchingId(motivationalQuotes, localCopy)
    )
      .then(() => {
        setIsEditing(false)
        createAlert({ message: 'Successfully saved motivational quote' })
      })
      .catch(createGenericErrorAlert)
  }

  const { quoteText, color } = localCopy

  return (
    <>
      {isEditing && (
        <Box sx={{ display: 'flex', width: '100%', alignItems: 'center' }}>
          <TextField
            sx={{ minWidth: '400px', mx: 1 }}
            margin='dense'
            label='Note'
            onChange={(e) =>
              setLocalCopy((prev) => ({ ...prev, quoteText: e.target.value }))
            }
            value={localCopy.quoteText}
          />
          <TextField
            sx={{ minWidth: '300px', mx: 1 }}
            margin='dense'
            label='Color'
            onChange={(e) =>
              setLocalCopy((prev) => ({ ...prev, color: e.target.value }))
            }
            value={localCopy.color}
            select
          >
            {MOTIVATIONAL_QUOTE_COLOR_OPTIONS.map((c) => (
              <MenuItem key={c} value={c} sx={{ color: colors[c]?.[700] }}>
                {c.charAt(0).toUpperCase() + c.slice(1)}
              </MenuItem>
            ))}
          </TextField>
          <IconButton
            sx={{ flexShrink: 0, flexGrow: 0 }}
            onClick={() => {
              setIsEditing(false)
              setLocalCopy(motivationalQuotes[randomIndex])
            }}
          >
            <Close />
          </IconButton>
          <IconButton sx={{ flexShrink: 0, flexGrow: 0 }} onClick={onSave}>
            <Check />
          </IconButton>
        </Box>
      )}
      {!isEditing && (
        <Typography
          onDoubleClick={() => setIsEditing(true)}
          sx={{
            ml: 1,
            color: colors[color]?.[700],
            textAlign: 'center',
            fontSize: '24px',
            fontWeight: 'bold',
          }}
        >
          <i>{quoteText}</i>
        </Typography>
      )}
    </>
  )
}

export default MotivationalQuote
